import { saveAs } from 'file-saver';

export const downloadFile = (
  data: Uint8Array | Blob | string,
  filename: string,
  mimeType: string
): void => {
  try {
    let blob: Blob;
    
    if (data instanceof Uint8Array) {
      blob = new Blob([data], { type: mimeType });
    } else if (data instanceof Blob) {
      blob = data;
    } else {
      // String data
      blob = new Blob([data], { type: mimeType });
    }
    
    saveAs(blob, filename);
  } catch (error) {
    console.error('Download failed:', error);
    throw new Error(`Failed to download file: ${error}`);
  }
};

export const downloadCSV = (data: Uint8Array | string, filename?: string): void => {
  const csvFilename = filename || `query_results_${new Date().toISOString().split('T')[0]}.csv`;
  downloadFile(data, csvFilename, 'text/csv;charset=utf-8');
};

export const downloadParquet = (data: Uint8Array, filename?: string): void => {
  const parquetFilename = filename || `query_results_${new Date().toISOString().split('T')[0]}.parquet`;
  downloadFile(data, parquetFilename, 'application/octet-stream');
};

export const generateFilename = (baseFilename: string, extension: string): string => {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
  const sanitizedBase = baseFilename.replace(/[^a-zA-Z0-9_-]/g, '_');
  return `${sanitizedBase}_${timestamp}.${extension}`;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}; 